import React from 'react';
import { actions, elements } from '@ecosystem/newron-design-system';

import { ClientSidebar } from '../content';

export const FilterPanel = ({ children }) => {
  const { closeSidebar } = ClientSidebar.useSidebar();

  return (
    <ClientSidebar.Content>
      <div className="absolute inset-0 flex flex-column">
        <div className="flex items-center border-b border-light py-5 px-4 h-19 flex-shrink-0">
          <h2 className="flex-1 text-xl font-normal">Filters</h2>
          <actions.IconButton testId="close-drawer-button" onClick={closeSidebar} color="secondaryInteractive">
            <elements.Icon.icons.Close />
          </actions.IconButton>
        </div>
        <div className="flex-column h-full overflow-auto">{children}</div>
      </div>
    </ClientSidebar.Content>
  );
};
